import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import isObject from 'lodash.isobject';
import { popupReducer, popupInitialState } from './popup/reducer';
import * as popupActions from './popup/actions';
import { useStateWithActions } from './utils';
import { POPUP_SETTINGS } from '../../constants/popups';

export const PopupContext = React.createContext();
PopupContext.displayName = 'PopupContext';

export const PopupContextProvider = ({ children }) => {
    const initState = initialState => {
        const storageDataValidation = storageData => {
            if (storageData === undefined) {
                return initialState.userPopupsSettings;
            }
            const parseData = JSON.parse(storageData);
            return isObject(parseData) && !isEmpty(parseData)
                ? parseData
                : initialState.userPopupsSettings;
        };

        const rawPopupsSetting = localStorage.getItem(POPUP_SETTINGS);
        const userPopupsSettings = storageDataValidation(rawPopupsSetting);

        return { ...initialState, userPopupsSettings };
    };
    const [actions, state] = useStateWithActions(
        popupActions,
        popupReducer,
        popupInitialState,
        initState,
    );

    useEffect(() => {
        localStorage.setItem(POPUP_SETTINGS, JSON.stringify(state.userPopupsSettings));
    }, [state.userPopupsSettings]);

    return <PopupContext.Provider value={{ actions, ...state }}>{children}</PopupContext.Provider>;
};

PopupContextProvider.propTypes = {
    children: PropTypes.node,
};

PopupContextProvider.defaultProps = {
    children: null,
};

export default PopupContextProvider;

// helper function

export const usePopupContext = () => React.useContext(PopupContext);
